import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { pickCardAct, unPickCardAct } from "../domain/slice/tarot-slice";
import tarotBack from  './../../../assets/images/tarot_back.jpg'

export default function CardsRead() {
  const { pickedCardsIndex } = useAppSelector((state) => state.TarotSlice)
  const dispatch = useAppDispatch()
  const array = [0,1,2,3,4,5,6,7,8,9,10]

  const pickCard = ({index, row}: {index: number, row: number}) => {
    const isPicked = pickedCardsIndex.findIndex((v) => (v.index === index && v.row === row)) !== -1
    
    if(isPicked) {
      dispatch(unPickCardAct({index, row}))
    } else {
      if(pickedCardsIndex.length < 3) dispatch(pickCardAct({index, row}))
    }
  }
  return (
    <>
      <div className='content-cards'>
        <div className="card-to-read">
          {array.map((e, i) => {
            let className = "card"
            if(pickedCardsIndex.findIndex((v) => (v.index === i && v.row === 0)) !== -1) className = "card picked"
            return (<div key={`card_to_read_0_${i}`} className={className} style={{left: `${i*7}%`, zIndex: i*10}} onClick={(e) =>pickCard({index: i, row: 0})}>
              <img src={tarotBack} alt="" />
            </div>)
          }
          )}
        </div>
        <div className="card-to-read">
          {array.map((e, i) => {
            let className = "card"
            if(pickedCardsIndex.findIndex((v) => (v.index === i && v.row === 1)) !== -1) className = "card picked"
            return (<div key={`card_to_read_1_${i}`} className={className} style={{left: `${i*7}%`, zIndex: i}} onClick={(e) =>pickCard({index: i, row: 1})}>
              <img src={tarotBack} alt="" />
            </div>)
          }
          )}
        </div>
      </div>
    </>
  )
}